/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/
import Input from '../../components/formComponents/input';


/*Assets*/

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';





class SignupTab5 extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: ""
    }
  }

  buttonClick(e){
    if(this.state.confirm != this.state.password){
      this.setState({error: "Confirm password must same as new password."});
    }
    else{
      var url = devconfig.vendor+'auth/create-password';
      var data = JSON.stringify({
        "key" : "663262",
        "email" : this.props.mail,
        "password": this.state.password
      })
      APIPost(url,data).then(function(response){
        if(response.status == "ok"){
          window.location.href = 'https://evoque-truekhoj-vendor.netlify.app/';
        }
        else{
          this.setState({error: response.message});
        }
      }.bind(this))
    }
  }

  render() {
    if(this.state.apiLoading){
      return(
        null
      )
    }
    return (
      <div className="col-lg-6 col-10 mx-auto e-outer-wrap p-5">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h5>Verification Success!</h5>
          </div>
        </div>
        <div className="row pt-3">
          <div className="col-lg-12 text-center">
            <span className="e-verify-success"></span>
            <p>Thank you for verifying mobile number. We will review your detail and send a verification mail.</p>
          </div>
        </div>

        
        
        
        <div className="row">
          <div className="col-lg-12 mt-3 text-center">
            <a href="./">
              <span className="e-signup-btn">Go to login</span>
            </a>
          </div>
        </div>

      </div>
    );
  }
}

export default SignupTab5;
